import React, { useEffect, useState } from "react";
import { useParams } from 'react-router';
import Snackbar from '@mui/material/Snackbar';
import _ from "underscore";

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";

import EditDialog from './edit-dialog';
import AddDialog from "./add-dialog";

function FarmTransportVehicles() {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [configuration, setConfiguration] = useState({});
    const [showEditDialog, setShowEditDialog] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState();
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");
    const [showAddDialog, setShowAddDialog] = React.useState(false);

    useEffect(() => {
        fetchData();
        fetchConfigurations();
    }, []);

    const fetchData = () => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles`)
            .then(response => response.json())
            .then(json => {
                console.log(json);
                const vehicle_data = _.where(json, {
                    vendor_id: id
                });
                setData(vehicle_data);
            })
            .catch(error => console.error(error));
    };

    const fetchConfigurations = () => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_configurations`)
            .then(response => response.json())
            .then(json => setConfiguration(json))
            .catch(error => console.error(error));
    };

    const showInMapClicked = (lat, lng) => {
        window.open("https://maps.google.com?q=" + lat + "," + lng);
    };

    const getAvailableDate = (date) => {
        var dt = new Date(date);
        const addOnTime = configuration.loading_time + configuration.unloading_time + configuration.wait_time + configuration.changeover_time;
        dt.setHours(dt.getHours() + addOnTime);
        return isNaN(dt) ? "-" : dt.toLocaleString();
    };

    const handleEditOpen = () => {
        setShowEditDialog(true);
    };

    const handleEditClose = () => {
        setShowEditDialog(false);
    };

    const handleEditSave = (data) => {
        setShowEditDialog(false);
        if (data.vehicle_no !== selectedValue.vehicle_no || data.vehicle_type !== selectedValue.vehicle_type || data.capacity !== selectedValue.capacity) {
            fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles/${selectedValue.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    vehicle_id: selectedValue.vehicle_id,
                    vendor_id: selectedValue.vendor_id,
                    vehicle_no: data.vehicle_no,
                    vehicle_type: data.vehicle_type,
                    location: selectedValue.location,
                    capacity: data.capacity,
                    status: selectedValue.status
                })
            })
                .then(response => response.json())
                .then(json => {
                    fetchData();
                    setShowSnackbar(true);
                    setSnackbarMessage("Data updated successfully.");
                })
                .catch(error => {
                    setShowSnackbar(true);
                    setSnackbarMessage("Error while updating data.");
                });
        } else {
            setShowSnackbar(true);
            setSnackbarMessage("No changes found.");
        }
    };

    const handleAddOpen = () => {
        setShowAddDialog(true);
    };

    const handleAddClose = () => {
        setShowAddDialog(false);
    };

    const handleAddSave = (data) => {
        if (data.vehicle_id && data.vendor_id && data.vehicle_no && data.vehicle_type && data.location.name && data.location.lat && data.location.lng && data.capacity) {
            setShowAddDialog(false);
            fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(json => {
                    fetchData();
                    setShowSnackbar(true);
                    setSnackbarMessage("Data added successfully.");
                })
                .catch(error => {
                    setShowSnackbar(true);
                    setSnackbarMessage("Error while adding data.");
                });
        } else {
            setShowSnackbar(true);
            setSnackbarMessage("Please enter all the details.");
        }
    };

    const deleteOrder = (data) => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles/${data.id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(json => {
                fetchData();
                setShowSnackbar(true);
                setSnackbarMessage("Data deleted successfully.");
            })
            .catch(error => {
                setShowSnackbar(true);
                setSnackbarMessage("Error while deleting data.");
            });
    };

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Vehicles"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            {/* <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul> */}
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            {/* <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div> */}
                                            {/* <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div> */}
                                            <div id="plan-insert-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-table-plus" onClick={handleAddOpen}></i>
                                            </div>
                                            <div id="plan-upload-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-upload"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                    id="plan-schedule-table">
                                                    <thead>
                                                        <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                            <th>Vehicle No.</th>
                                                            <th>Vehicle Type</th>
                                                            <th>Location</th>
                                                            <th>Capacity</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="table-list-body">
                                                        {data.map((dt, i) =>
                                                            <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                id={`row-` + i} key={i} data-id="1">
                                                                <td data-type="text" name="vehicle_no">{dt.vehicle_no}</td>
                                                                <td data-type="text" name="vehicle_type" style={{ textTransform: 'capitalize' }}>{dt.vehicle_type}</td>
                                                                <td data-type="text" name="location" onClick={() => showInMapClicked(dt.location.lat, dt.location.lng)} style={{ cursor: 'pointer', color: '#134896' }}>
                                                                    {dt.location.name}
                                                                </td>
                                                                <td data-type="text" name="capacity">{dt.capacity}</td>
                                                                {dt.status === 'available' &&
                                                                    <td data-type="text" name="status">Available</td>
                                                                }
                                                                {dt.status !== 'available' &&
                                                                    <td data-type="text" name="status">
                                                                        <div>{"Assigned to #" + dt.assigned_order}</div>
                                                                        <div>{"Next available on " + getAvailableDate(dt.assigned_date)}</div>
                                                                    </td>
                                                                }
                                                                <td>
                                                                    {dt.status === 'available' &&
                                                                        <>
                                                                            <i className="f-24 i-btn cursor-pointer ti ti-edit" onClick={() => { setSelectedValue(dt); handleEditOpen(); }}></i>
                                                                            <i className="f-24 i-btn cursor-pointer ti ti-trash-x" onClick={() => deleteOrder(dt)}></i>
                                                                        </>
                                                                    }
                                                                </td>
                                                            </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <EditDialog
                        selectedValue={selectedValue}
                        open={showEditDialog}
                        onClose={handleEditClose}
                        onSave={handleEditSave}
                    />
                    <AddDialog
                        open={showAddDialog}
                        onClose={handleAddClose}
                        onSave={handleAddSave}
                    />
                    <Snackbar
                        open={showSnackbar}
                        autoHideDuration={2000}
                        onClose={() => setShowSnackbar(false)}
                        message={snackbarMessage}
                    />
                </div>
            </main>
        </div>
    );
}
export default FarmTransportVehicles;